hrd.Form = hrd.Class.extend({
	FIELD_SELECTOR: 'input:not([data-ignore="true"]):not(.filter-field), select, textarea, span[data-type="radio"], span[data-type="checkbox"]',
	DIV_SELECTOR: 'div[data-type]:not([class*="choice-group"]), span[data-type]:not([class*="choice-group"]), img[data-type], h1[data-type], h2[data-type], h3[data-type], p[data-type]',
	BTN_SELECTOR: 'button[data-action], div[data-action]',
	ENHANCE_PHASE_PROMISES: 'enhance-phase-promises',
	OBJECT_PHASE_PROMISES: 'object-phase-promises',
	init: function(container, options) {
		options = options || {};
		var defaults = {
			impl: 'hrd.Form',
			inputData: undefined, // can be used to give an initial object to this form
			reference: undefined,
			innerFormButtonsFn: undefined,
			labelsOnTop: false,
			errorMessagePosition: 'element', // Can be either "top" or "element" or "custom"
			errorMessageCustom: undefined,
			errorMessageParentSelector: '.field-composite',
			ignoreValidationWhenHidden: false, // if true hidden fields will be not validated
			arrangeFieldSet: false,
			ignoreArrangeFieldSet: false,
			buttonStyles: 'squared',
			selectable: false,
			autocomplete: undefined
		};
		this._super($.extend({}, defaults, options));
		this.componentFactory = new hrd.core.ComponentFactory({ verbose: false, formInstance: this });
		this.toolbox = new hrd.Toolbox();

		var $form = $('form', container);
		if (!$form.exists()) {
			var fieldset = $('fieldset', container);
			$form = $('<form></form>').prependTo(fieldset.parent()).append(fieldset.detach());
			if (this.settings.autocomplete != undefined) {
				$form.attr('autocomplete', this.settings.autocomplete);
			}
		}
		$form.addClass('hrd-form').on('submit', function(event) {
			event.preventDefault();
			return false;
		}).off('change.form').on('change.form', (event) => {
			var $target = $(event.target);
			var skip = ($target.data('ignore') == true) || ($target.hasClass('filter-field'));
			if (!skip) {
				this.makeFormEdited();
			}
		})
		this.container = container;
		this.$form = $form;
		this.$container = $(container);
		this.buttons = {};
		// listeners
		if (options.onSetDataForm) {
			this.$container.on('set-data-form', function(event) {
				options.onSetDataForm.call(this, event, this);
			}.bind(this));
		}
	},
	addPromise: function(promise, type) {
		var promises = $(this.container).data(type) || [];
		promises.push(promise);
		$(this.container).data(type, promises);
	},
	getPromises: function(type) {
		var promises = $(this.container).data(type) || [];
		$(this.container).removeData(type);
		return promises;
	},
	alreadyEnhanced: function(value) {
		if (value == undefined) {
			return $(this.container).data('form-enhanced') || false;
		} else {
			$(this.container).data('form-enhanced', value);
		}
	},
	clearObjectPhasePromises: function() {
		let type = this.OBJECT_PHASE_PROMISES;
		$(this.container).removeData(type); // pulisco le promise
	},
	setInputData: function(inputData) {
		this.settings.inputData = inputData;
	},
	clearFieldset: function() {
		this.$container.find('fieldset').empty();
	},
	enhanceAgain: function() {
		// remove enhanced marker
		this.alreadyEnhanced(false);

		// need to clear all cached components inside container in order to be recreated correctly
		$(this.FIELD_SELECTOR, this.container).each((index, field) => {
			var $f = $(field);
			var type = $f.data('type');
			let name = this.toPropertyName($f);
			this.componentFactory.clearKey(name, type, 'edit');
		});
		$(this.DIV_SELECTOR, this.container).each((index, field) => {
			var $f = $(field);
			var type = $f.data('type');
			let name = this.toPropertyName($f);
			this.componentFactory.clearKey(name, type, 'read');
		});
		//

		return this.enhance();
	},
	enhanceBlock: function(selector) {
		const originalContainer = this.container;
		const $block = $(selector);
		this.container = $block;

		return this.enhanceAgain()
			.then(() => {
				this.container = originalContainer;
			});
	},
	enhance: function() {
		var deferred = $.Deferred();
		var alreadyEnhanced = this.alreadyEnhanced();
		if (!alreadyEnhanced) {
			// mark as enhanced for future calls
			this.alreadyEnhanced(true);

			// enhance fieldset part
			var $fieldset = $('fieldset', this.container);
			$fieldset.addClass('dashlet-fieldset ui-widget ui-widget-content ui-corner-bottom');
			var $legend = $('legend', this.container);
			if ($legend.exists()) {
				$('legend', this.container).addClass('dashlet-legend ui-state-default ui-corner-all');
			} else {
				$fieldset.addClass('no-legend');
			}

			// force labelsOnTop if needed
			if (this.settings.labelsOnTop) {
				$('.field-composite:not(.ignore-label-on-top)', this.container).each((j, fc) => {
					$(fc).addClass('label-on-top');
					$('label', fc).addClass('ignore-aw');
				});
			}

			$(this.FIELD_SELECTOR, this.container).each((index, field) => {
				var $f = $(field);
				this.enhanceEditField($f);
				if ($f.data('hidden')) {
					this.hideField($f);
				}
				this.toggleEnablementByProperty($f);
				this.toggleVisibilityByProperty($f);
			});
			$(this.DIV_SELECTOR, this.container).each((index, field) => {
				var $f = $(field);
				this.enhanceReadField($f);
				if ($f.data('hidden')) {
					this.hideField($f);
				}
				this.toggleVisibilityByProperty($f);
			});
		} else {
			$(this.FIELD_SELECTOR, this.container).each((index, field) => {
				var $f = $(field);
				this.reEnhanceEditField($f);
			});
			$(this.DIV_SELECTOR, this.container).each((index, field) => {
				var $f = $(field);
				this.reEnhanceReadField($f);
			});
		}

		// enhance additional internal buttons, must be done each time due to 'variable-caching' of event-listener functions
		$(this.BTN_SELECTOR, this.container).each((index, button) => {
			var $btn = $(button);
			this.enhanceButton($btn);
			this.toggleVisibilityByProperty($btn);
		});

		// needed to resolve the enhancement only when all select1 providers has been completed, if they are lazy....
		var formInnerPromises = this.getPromises(this.ENHANCE_PHASE_PROMISES);
		if (formInnerPromises && formInnerPromises.length > 0) {
			$.when.all(formInnerPromises).then(function() {
				deferred.resolve();
			})
		} else {
			deferred.resolve();
		}
		// prepare dynamic labels:
		if (this.settings.labels != undefined) {
			/* kept for backward compatibility. It will be replaced by the new 'data-use-label' */
			$('label[data-label]', this.container)
				.each((_, label) => {
					let $label = $(label);
					let text = this.settings.labels[$label.data('label')];
					if (text != undefined) {
						$label.html(text);
					}
				});
			$('*[data-use-label]', this.container)
				.each((_, label) => {
					let $label = $(label);
					let text = this.settings.labels[$label.data('useLabel')];
					if (text != undefined) {
						if($label.is('button')) {
							$label.attr('title', text);
						} else {
							$label.html(text);
						}
					}
				});
		}
		/* arrange fieldset if specified just before returning */
		this.arrangeFieldSet();
		this.postProcessAfterArrangeFieldset();
		return deferred.promise();
	},
	arrangeFieldSet: function() {
		if (this.settings.arrangeFieldSet && !this.settings.ignoreArrangeFieldSet) {
			var afsOptions = this.settings.arrangeFieldSet === true ? {} : this.settings.arrangeFieldSet;
			this.arrangeFieldValues = hrd.dashboard.dashlet.arrangeFieldSet(this.container, afsOptions);
		}
	},
	/* per ora serve solo per file attachment*/
	postProcessAfterArrangeFieldset: function() {
		$(this.FIELD_SELECTOR, this.container).each((index, f) => {
			var field = $(f);
			var type = field.data('type');
			switch (type) {
				case 'file':
					var fileInfo = field.data('fileInfo');
					if (fileInfo && fileInfo.showAttachments) {
						var $composite = field.closest('.field-composite');
						var $attachmentsZone = $('.attachments-zone', $composite);
						var $label = $('label[for=' + field.attr('id') + ']', $composite);
						if ($label.exists()) {
							var labelWidth = $label.outerWidth(true);
							$attachmentsZone.css({
								width: 'calc(100% - ' + labelWidth + 'px)',
								left: labelWidth + 'px'
							});
						}
					}
					break;
				default:
					break;
			}
		});
	},
	getField: function(f) {
		if (f instanceof jQuery) {
			return f;
		} else if (typeof f == 'string') {
			// use as id
			let fid = (f.startsWith('#')) ? f : ('#' + f);
			var $field = $(fid, this.$form); // find inside form in order to avoid misunderstanding with 'body' or 'title'
			if (!$field.exists()) {
				// use as data-name
				$field = this.getFieldReferenceByName(f);
				if (!$field.exists()) {
					// use as data-action (a button)
					$field = this.getFieldReferenceByAction(f);
				}
			}
			return $field;
		} else {
			return $('-none-');
		}
	},
	getFieldReferenceByName: function(name) {
		return $('*[data-name="' + name + '"]', this.container);
	},
	getFieldsReferenceByType: function(type) {
		return $('*[data-type="' + type + '"]', this.container);
	},
	getFieldReferenceByAction: function(name) {
		return $('*[data-action="' + name + '"]', this.container);
	},
	getFieldReferenceByData: function(dataName, value) {
		let dataNameDashed = $.dashedCase(`data-${dataName}`);
		return $(`*[${dataNameDashed}="${value}"]`, this.container);
	},
	changeFieldLabel: function(field, label) {
		var $f = this.getField(field);
		var $label = $f.closest('.field-composite').find('label');
		if ($label.exists()) {
			$label.html(label);
		}
	},
	enhanceEditField: function(field) {
		// double check  on data-ignore
		if (field.data('ignore') == true) {
			return;
		}

		let id = field.uniqueId().attr('id'); // add uniqueid if not yet available
		let label = field.siblings('label').each((i, l) => {
			if ($(l).attr('for') == undefined) {
				$(l).attr('for', id);
			}
		});
		if (field.attr('name') === undefined) {
			field.attr('name', id);
		}
		let name = this.toPropertyName(field);

		let type = field.data('type');
		if (type == undefined) {
			// if type is missing, then 'text'
			console.error(`An EDITable field without a type: name= "${name}". Forced to "text"`);
			type = 'text';
			field.attr('data-type', type);
		}
		if (field.data('max-width')) {
			field.css({
				width: field.data('max-width'),
				maxWidth: field.data('max-width')
			})
		}
		if (field.data('min-width')) {
			field.css({
				minWidth: field.data('min-width')
			})
		}
		if (field.data('exactWidth')) {
			field.css({
				width: field.data('exactWidth'),
				minWidth: field.data('exactWidth'),
				maxWidth: field.data('exactWidth')
			})
		}
		if (field.data('exactHeight')) {
			field.css({
				height: field.data('exactHeight'),
				minHeight: field.data('exactHeight'),
				maxHeight: field.data('exactHeight')
			})
		}

		let component = this.componentFactory.factory(name, type, 'edit');

		/* specs for any field */
		var klass = `ui-widget-content ui-corner-all editable-data ${type}-field`;
		if (component != null) {
			// during enhancements a field can be totally replaced with something else, in such case the 'field' variable must be updated
			let replacedField = component.enhanceField(field, id, klass);
			if (replacedField != undefined) {
				field = replacedField;
			}
		} else {
			console.error(`Enhancing a EDIT field of unknown type: "${type}" (name= "${name}")`);
			field.addClass(klass);
		}

		/* used to activate help trigger, if needed */
		this.activateHelp(field);

		/* used to activate copy to clipboard, if needed */
		this.activateCopyToClipboard(field);

		/* adding custom events functions */
		var events = field.data('events');
		events = events ? events.split(' ') : [];
		$.each(events, (index, evt) => {
			var id = field.attr('id');
			var eventOptions = field.data(`event-${evt}`);
			if (eventOptions !== undefined) {
				if (!$.isPlainObject(eventOptions) && !$.isArray(eventOptions)) {
					var evaluate = 'eventOptions = ' + eventOptions + ';';
					eventOptions = eval(evaluate);
				}
			}
			var skipObject = eventOptions !== undefined && eventOptions.output == false;
			var doNotForceBlur = eventOptions !== undefined && eventOptions.doNotForceBlur == true;

			var eventName = ((id.indexOf('ui-id') == 0) ? field.data('name') : id) + '-' + evt;
			var fnName = $.functionCase(eventName);
			if (this.settings.reference && typeof this.settings.reference[fnName] === 'function') {
				const debounceDelay = eventOptions && (eventOptions.debounce * 1);
				// search for a function in the "container/reference" object
				const eventFunction = (e, eventData) => {
					var deferred = $.Deferred();
					if (e.type == 'change') {
						// GB #4184: need to avoid forcing blur for 'change' event because when loosing focus
						// clicking outside the window will generate too much recursion (on firefox only)
						doNotForceBlur = true;
					}
					var formData = skipObject ? {} : this.toObject(undefined, { doNotForceBlur: doNotForceBlur });
					// due to a mistake an for backward compatibility, originator event is not the first argument but the fourth. changing this need a full regression test
					// TODO: replace field with evt. field is retrieavable from evt using 'target'
					var promise = this.settings.reference[fnName].call(this.settings.reference, field, formData, this, e, eventData);
					$.when(promise)
						.then(() => deferred.resolve())
						.fail(() => deferred.reject());
					this.addPromise(deferred.promise(), this.OBJECT_PHASE_PROMISES);
				};

				if (debounceDelay && debounceDelay !== NaN) {
					field.on(evt, $.debounce(eventFunction, debounceDelay));
				} else {
					field.on(evt, eventFunction);
				}
			} else {
				var ref = this.settings.reference ? (this.settings.reference._FULL_ ? this.settings.reference._FULL_ : this.settings.reference) : 'unknown';
				console.log(`Add "${fnName}: function(field, formData, formInstance, evt) {}," to proper object reference "${ref}"`);
			}
		});

		/*
		 * #2157: fix due to wrong behaviour if ubuntu-firefox: alt-gr triggers a spurious 'blur' event.
		 * 		  because this happens when te cursor is inside a field, this blur event is followed immediately by a 'focus'
		 * 		  in order to detect this a threashold of 100 millisecond will be used to understand if the blur was 'manual' or 'spurious'
		 */
		field
			.off('.enh')
			.on('blur.enh', (event) => {
				this.millis = new Date().getTime();
				this.blurredFromField = $(event.currentTarget).attr('id');
			})
			.on('focus.enh', (event) => {
				var selectAll = true;
				if (this.millis && this.blurredFromField === $(event.currentTarget).attr('id')) {
					var delta = (new Date().getTime() - this.millis);
					if (delta < 100) {
						selectAll = false;
					}
				}
				if (selectAll) {
					var $tg = $(event.currentTarget);
					if (!$tg.hasClass('skip-select')) {
						$tg.select();
					}
				}
			});
	},
	enhanceReadField: function(field) {
		var id = field.uniqueId().attr('id'); // add uniqueid if not yet available
		var type = field.data('type');
		let name = this.toPropertyName(field);

		/* specs for any field */
		let klass = `read-only-data ${type}-field`;
		if (this.settings.selectable) {
			klass += ' selectable';
		}
		if (field.data('max-width')) {
			field.css({
				width: field.data('max-width'),
				maxWidth: field.data('max-width')
			})
		}
		if (field.data('min-width')) {
			field.css({
				minWidth: field.data('min-width')
			})
		}
		if (field.data('exactWidth')) {
			field.css({
				width: field.data('exactWidth'),
				minWidth: field.data('exactWidth'),
				maxWidth: field.data('exactWidth')
			});
		}
		if (field.data('height')) {
			field.css({
				height: dashboardInstance.adaptSize(field.data('height'))
			});
		}
		if (field.data('exactHeight')) {
			field.css({
				height: field.data('exactHeight'),
				minHeight: field.data('exactHeight'),
				maxHeight: field.data('exactHeight')
			})
		}
		if (field.data('placeholder')) {
			field.append($(`<span class="placeholder">${field.data('placeholder')}</span>`));
		}

		let component = this.componentFactory.factory(name, type, 'read');
		if (component) {
			component.enhanceField(field, id, klass);
		} else {
			console.error(`Enhancing a READ field of unknown type: "${type}" (name= "${name}")`);
			field.addClass(klass);
		}
		/* used to activate help trigger, if needed */
		this.activateHelp(field);

		/* used to activate copy to clipboard, if needed */
		this.activateCopyToClipboard(field);

		/* adding custom events functions */
		var events = field.data('events');
		events = events ? events.split(' ') : [];
		$.each(events, (index, evt) => {
			var id = field.attr('id');
			var eventOptions = field.data('event-' + evt);
			if (eventOptions !== undefined) {
				var evaluate = 'eventOptions = ' + eventOptions + ';';
				eventOptions = eval(evaluate);
			}
			var skipObject = eventOptions !== undefined && eventOptions.output == false;
			var eventName = ((id.indexOf('ui-id') == 0) ? field.data('name') : id) + '-' + evt;
			var fnName = $.functionCase(eventName);
			if (this.settings.reference && typeof this.settings.reference[fnName] == 'function') {
				// search for a function in the "container/reference" object
				field.on(evt, function(e) {
					var deferred = $.Deferred();
					var formData = skipObject ? {} : this.toObject(undefined);
					// due to a mistake an for backward compatibility, originator event is not the first argument but the fourth. changing this need a full regression test
					// TODO: replace field with evt. field is retrieavable from evt using 'target'
					var promise = this.settings.reference[fnName].call(this.settings.reference, field, formData, this, e);
					$.when(promise)
						.then(() => deferred.resolve())
						.fail(() => deferred.reject());
					this.addPromise(deferred.promise(), this.OBJECT_PHASE_PROMISES);
				}.bind(this));
			} else {
				console.log('function "' + fnName + '" not available in proper object reference "' + this.settings.reference._FULL_ + '"');
			}
		});

	},
	enhanceButton: function(btn) {
		const usingChromaFlow = $(btn).usingChromaFlow();

		var id = btn.uniqueId().attr('id'); // add unique-id if not yet available
		if (!btn.data('ignore-box-sizing') == true) {
			// added because of icon only buttons, that uses content-box til a refactoring
			btn.css('box-sizing', 'border-box');
		}
		if (btn.data('width')) {
			let w = dashboardInstance.adaptSize(btn.data('width'));
			btn.css('width', w);
		}
		if (btn.data('height')) {
			let h = dashboardInstance.adaptSize(btn.data('height'));
			btn.css('height', h);
		}
		var showText = true;
		if (btn.data('showText') !== undefined) {
			showText = btn.data('showText');
		}
		if (btn.data('default') == true) {
			btn.addClass('ui-state-focus ui-default-button');
		}
		var disabled = false;
		if (btn.data('disabled') == true) {
			disabled = true;
		}

		// button styles
		var buttonStyles = btn.data('styles') || this.settings.buttonStyles;
		btn.addClass(buttonStyles);
		if (btn.data('reverse') == true || (buttonStyles.indexOf('reverse') != -1 && !(btn.data('reverse') == false))) {
			btn.addClass('button-reverse');
		}
		var dataMenu = btn.data('menu');
		var $menu = undefined;
		if (dataMenu != undefined) {
			var isObject = dataMenu.startsWith('{');
			if (isObject) {
				var menuInfo = $.evaluate(dataMenu);
				btn.data('menuInfo', menuInfo); // store for future use
				var action = btn.data('action');
				var reference = this.settings.reference;
				var menuDefFn = $.functionCase(action + '-menu-definition');
				if (reference && typeof reference[menuDefFn] == 'function') {
					var menuDefPromise = $.when(reference[menuDefFn].call(reference, btn));
					$menu = $('<ul class="ui-helper-hidden">');

					if (menuInfo.cssclass) {
						$menu.addClass(menuInfo.cssclass);
					}
					if (menuInfo.width) {
						$menu.attr('data-width', menuInfo.width);
					}
					if (menuInfo.height) {
						$menu.attr('data-height', menuInfo.height);
					}
					menuDefPromise.then((items) => {
						$.each(items, (i, item) => {
							item.label = item.label || item.action;

							$menu.append(`
								<li class="ui-state-enabled" data-menu-type="${item.action}" data-menu-id="${item.id}">
									<a href="#" onclick="return false;">${item.label}</a>
								</li>
							`);
						})
					});
					$('body').prepend($menu);
					this.addPromise(menuDefPromise, this.ENHANCE_PHASE_PROMISES);
				} else {
					$menu = $('none');
					console.log('Please, add "' + menuDefFn + '" function to reference as action menu definition function');
				}
			} else {
				$menu = $('#' + dataMenu);
				btn.data('menuInfo', {}); // store for future use
				if ($menu.exists()) {
					$('body').append($menu.detach());
				}
			}

			/* apply permissions rules if needed */
			$('li[data-menu-type]', $menu).each((i, item) => {
				var $item = $(item);
				var itemPermission = $item.data('permission');
				if (itemPermission) {
					if (dashboardInstance.hasPermissionData(itemPermission)) {
						if (dashboardInstance.hasPermission(itemPermission)) {
							$item.show();
							$item.removeClass('hidden-item')
						} else {
							$item.hide();
							$item.addClass('hidden-item')
						}
					} else {
						console.log('Permission "' + itemPermission + '" has been added to item "' + $item.data('menu-type') + '", but it is not defined in dashboard permission list')
					}
				}
			});

			if (usingChromaFlow) {
				$menu.addClass('popover command closed');
			}
		} else {
			$menu = $('none');
		}

		var classes = (btn.data('class') == 'icon-button') ? 'dashlet-icon-button' : (btn.data('class') == 'legend-button') ? 'dashlet-legend-button' : 'dashlet-button inner-form-button';

		if (btn.data('spin-on-hover') == true) {
			btn.hover(() => btn.children('span.f-icon').addClass('fa-spin'), () => btn.children('span.f-icon').removeClass('fa-spin'));
		}

		btn.addClass(classes).removeClass('ui-state-active').button({
			icons: {
				primary: btn.data('icon-primary') != undefined ? 'f-icon ' + btn.data('icon-primary') : undefined,
				secondary: btn.data('icon-secondary') != undefined ? 'f-icon ' + btn.data('icon-secondary') : undefined
			},
			text: showText,
			disabled: disabled
		}).off('click.ifb').on('click.ifb', function(event) {
			/* test if button is disabled, if so do nothing */
			var isDisabled = btn.button('option', 'disabled');
			if (!isDisabled) {
				var action = btn.data('action');
				var validate = btn.data('validation') == true;
				var freshObject = btn.data('fresh-object') == true;
				if (action) {
					var formData = freshObject ? this.toObject({}) : this.toObject();
					if ($menu.exists()) {
						var actionMenuFn = undefined;
						var reference = this.settings.reference;
						var useDispatcher = false;
						var menuInfo = btn.data('menuInfo');
						var actionMenuBeforeOpenFn = undefined;
						if (reference) {
							var actionMenu = $.functionCase(action + '-menu-action');
							var actionMenuDispatcher = $.functionCase('dispatcher-menu-action');
							if (typeof reference[actionMenu] == 'function') {
								actionMenuFn = reference[actionMenu]
							} else if (typeof reference[actionMenuDispatcher] == 'function') {
								useDispatcher = true;
								actionMenuFn = reference[actionMenuDispatcher];
							}
							if (btn.data('menuBeforeOpen') != undefined) {
								var actionMenuBeforeOpen = $.functionCase(action + '-menu-before-open');
								if (typeof reference[actionMenuBeforeOpen] == 'function') {
									actionMenuBeforeOpenFn = reference[actionMenuBeforeOpen];
								} else {
									console.log(`Function "${actionMenuBeforeOpen}" not available in proper object reference "${reference._FULL_}"`);
								}
							}
						}
						if (actionMenuFn != undefined) {
							// close tooltip
							btn.tooltip().tooltip("close");
							// close all other menu instances
							$('.ui-menu').hide();

							var menuCssOptions = {
								'position': 'absolute',
								'z-index': '1200', // should be higher than dialogs (1002)
								top: 'unset',
								bottom: 'unset',
								left: 'unset',
								right: 'unset',
							};
							if ($menu.data('width')) {
								menuCssOptions.width = dashboardInstance.adaptSize($menu.data('width'));
							} else {
								menuCssOptions.width = btn.width();
							}
							if ($menu.data('height')) {
								menuCssOptions.height = dashboardInstance.adaptSize($menu.data('height'));
							}

							$menu.menu({
								select: function(evt, ui) {
									btn.data('current-data-menu-item', ui.item.attr('data-menu-type'));
									if (useDispatcher) {
										actionMenuFn.call(reference, action, ui.item.attr('data-menu-type'), ui.item, formData);
									} else {
										actionMenuFn.call(reference, ui.item.attr('data-menu-type'), ui.item, formData, this);
									}
								}.bind(this)
							});

							// useful to remove 'rounded-corners' on selected elements when '2x'
							if ($menu.hasClass('items-2x')) {
								$('li[data-menu-type] a', $menu).each((i, item) => {
									$(item).removeClass('ui-corner-all');
								});
							}

							/* to be executed before opening...*/
							let beforeOpenPromise;
							if (actionMenuBeforeOpenFn != undefined) {
								beforeOpenPromise = $.when(actionMenuBeforeOpenFn.call(reference, formData, $menu));
							} else {
								beforeOpenPromise = $.when();
							}

							beforeOpenPromise.then(() => {
								if (usingChromaFlow) {
									if (!$('.ui-menu-item', $menu).parent('.ui-menu-group').exists()) {
										$('.ui-menu-item', $menu).wrapAll(`<div class="ui-menu-group"></div>`)
									}
								}

								$menu.show().css(menuCssOptions).position({
									my: "left top",
									at: "left bottom+4",
									of: btn
								});

								if (menuInfo.keepSelection) {
									$('li a', $menu).removeClass('ui-state-hover');
									var currentItem = btn.data('current-data-menu-item');
									if (currentItem != undefined) {
										$('li[data-menu-type="' + currentItem + '"] a', $menu).addClass('ui-state-hover');
									}
								}

								if (usingChromaFlow) {
									$menu
										.removeClass('closed')
										.attr('data-state', 'open');
								}
							});

							$(document).one('click', (event) => {
								if (usingChromaFlow) {
									$menu.attr('data-state', 'closed');
								} else {
									$menu.hide();
								}
							});

							event.stopPropagation(); //needed for viewing the drop down menu

							if (usingChromaFlow) {
								$('.ui-menu')
									.off('.animation')
									.on('animationend.animation', (event) => {
										event.stopPropagation();

										const isClosed = $(event.target).attr('data-state') === 'closed';
										$(event.target).toggleClass('closed', isClosed);
									});
							}
						} else {
							console.log(`Please, add "${actionMenu}" function in proper object reference "${reference._FULL_}" as action menu function`);
						}
					} else {
						var responsePromise;
						/*
						 * utility function that return a resolved promise if validation is not needed, and perfom validation otherwise.
						 * In this last scenario the function returns the promise returned back by validation itsel
						 *
						 */
						var validateIfNeededFn = () => {
							if (!validate) {
								return $.when();
							} else {
								return this.validate(formData);
							}
						};
						if (this.settings.reference && typeof this.settings.reference[action] == 'function') {
							/* goes here when opened in a dialog in which 'reference' and 'innerFormButtonsFn' settings are defined somehow */
							if (this.settings.innerFormButtonsFn && typeof this.settings.innerFormButtonsFn == 'function') {
								var keepDialogOpened = btn.data('keepDialogOpened');
								validateIfNeededFn()
									.then(() => {
										btn.button('disable').waiting();
										// needed for invoking the button callback directly on the main object. a promise may be returned
										responsePromise = this.settings.reference[action].call(this.settings.reference, event, formData, this);
										$.when(responsePromise).then(freshData => {
											// needed if the dialog button invokes something that will change the form itself
											var fd = (freshData == true) ? this.toObject() : formData;
											this.settings.innerFormButtonsFn(action, fd, keepDialogOpened);
										});
									})
									.fail(() => {
										if (typeof this.settings.reference['formValidationFailed'] == 'function') {
											this.settings.reference['formValidationFailed'].call(this.settings.reference, formData, this);
										}
									});
							} else {
								// reference is passed, so a function called 'action' is used
								validateIfNeededFn()
									.then(() => {
										btn.button('disable').waiting();
										responsePromise = this.settings.reference[action].call(this.settings.reference, event, formData, this);
									})
									.fail(() => {
										if (typeof this.settings.reference['formValidationFailed'] == 'function') {
											this.settings.reference['formValidationFailed'].call(this.settings.reference, formData, this);
										}
									});
							}
						} else {
							if (this.settings.reference) {
								console.log(`Button action NOT available. Add "${action}: function(event, formData, formInstance){}" method to: "${this.settings.reference._FULL_}"`);
							}
							var $target = $(event.currentTarget);
							validateIfNeededFn()
								.then(() => {
									btn.button('disable').waiting();
									responsePromise = $.broadcast($target, $.dashedCase(action), formData);
								});
						}

						$.when(responsePromise).always(function() {
							var alreadyActivated = btn.data('ignoreActivateOnReturn') || this.activateButtonByProperty(btn, formData);
							var ignoreWaitingDoneOnReturn = !!btn.data('ignoreWaitingDoneOnReturn');
							if (!alreadyActivated) {
								btn.button('enable');
							}
							if (!ignoreWaitingDoneOnReturn) {
								btn.waiting('done');
							}
						}.bind(this));
					}
				}
			}
		}.bind(this));
		// register buttons for programmatic invocation, but only if data-action is available
		var action = btn.data('action');
		if (action) {
			this.buttons[action] = btn;
		}
	},
	reEnhanceEditField: function(field) {
		let name = this.toPropertyName(field);
		let type = field.data('type');
		let component = this.componentFactory.factory(name, type, 'edit');
		if (component != null) {
			component.reEnhanceField(field);
		}
	},
	reEnhanceReadField: function(field) {
		let name = this.toPropertyName(field);
		let type = field.data('type');
		let component = this.componentFactory.factory(name, type, 'read');
		if (component != null) {
			component.reEnhanceField(field);
		}
	},
	/** AUTO HELP for Fields **/
	activateHelp: function(field) {
		if (field.usingChromaFlow()) {
			return;
		}

		let fieldHelpKey = field.data('help');
		if (fieldHelpKey != undefined) {
			let fieldHelp = xlate(fieldHelpKey);
			let appearance = field.data('help-appearance') || 'button'; // possible values: 'button'/'text'
			var type = field.data('type');
			let parentComposite = field.closest('.field-composite');
			let $helpContainer;
			let hasLabelOnTop = parentComposite.hasClass('label-on-top');
			let styles;
			switch (type) {
				case 'canvas':
					// todo: la posizione andrebbe ricalcolata al resize
					parentComposite.css('position', 'relative');
					let $canvas = field.find('canvas');
					let left = 16 + ((field.width() + $canvas.outerWidth(true)) / 2);
					$helpContainer = field;
					styles = {
						border: 'none',
						position: 'absolute',
						top: '50%',
						left: left
					};
					break;
				default:
					$helpContainer = parentComposite;
					styles = {
						border: 'none',
						position: 'relative',
						top: '-2px'
					};
					break;
			}
			if (hasLabelOnTop && appearance === 'button') {
				const $fieldWrapper = $(`<div class="wrapper-for-help-btn"></div>`);
				$fieldWrapper.append(field.detach());
				parentComposite.append($fieldWrapper);
				$helpContainer = $fieldWrapper;
				styles = {
					border: 'none',
					position: 'relative',
					top: '1px',
					right: '6px'
				};
			}

			if ($helpContainer.exists()) {
				if (appearance === 'text') {
					let $helpInline = `<div class="field-help-inline">${fieldHelp}</div>`;
					$helpContainer.append($helpInline);

					if (field.usingChromaFlow()) {
						const $inline = $(field)
							.parents('.field-composite')
							.find('.field-help-inline');

						$inline
							.add($inline.siblings(':not(label)'))
							.wrapAll('<div class="field-help-container"></div>')
					}
				} else {
					const reverseClass = !field.usingChromaFlow() ? 'button-reverse' : '';

					let $helpButton = $(`<button class="field-help-button ${reverseClass}"></button>`);
					$helpContainer.append($helpButton);
					$helpButton.button({
						icons: {
							primary: 'f-icon far fa-question-circle',
						},
						text: false,
						disabled: false
					})
						.css(styles)
						.off('click.help')
						.on('click.help', (event) => {
							$helpButton.tooltip({
								items: ".field-help-button",
								content: () => fieldHelp,
								close: function(event, ui) {
									var me = this;
									ui.tooltip.hover(
										function() {
											$(this).stop(true).fadeTo('400', 1);
										},
										function() {
											$.timeout(2500).then(() => {
												$(this).fadeOut('400', function() {
													$(this).remove();
												});
											});
										}
									);
									ui.tooltip.on('remove', function() {
										$(me).tooltip("destroy");
									});
								},
							});
							$helpButton.tooltip('open');
						});
				}
			}
		}
	},
	/** AUTO COPY TO CLIPBOARD for Fields **/
	activateCopyToClipboard: function(field) {
		let fieldCopyToClipboard = field.data('copyToClipboard');
		if (fieldCopyToClipboard == true) {
			var type = field.data('type');
			let parentComposite = field.closest('.field-composite');
			let $copyContainer;
			let hasLabelOnTop = parentComposite.hasClass('label-on-top');
			let styles;
			switch (type) {
				default:
					$copyContainer = parentComposite;
					styles = {
						border: 'none',
						position: 'relative',
						top: '-2px'
					};
					break;
			}
			if (hasLabelOnTop) {
				let $helpWrapper = $copyContainer.find('.wrapper-for-help-btn');
				if ($helpWrapper.exists()) {
					$copyContainer = $helpWrapper;
				} else {
					if (!field.usingChromaFlow()) {
						const $fieldWrapper = $(`<div class="wrapper-for-ctc-btn"></div>`);
						$fieldWrapper.append(field.detach());
						parentComposite.append($fieldWrapper);
						$copyContainer = $fieldWrapper;

					}
				}
				styles = {
					border: 'none',
					position: 'relative',
					top: '1px',
					right: '6px'
				};
			}

			if ($copyContainer.exists()) {
				const reverseClass = !field.usingChromaFlow() ? 'button-reverse' : '';

				let $ctcButton = $(`<button class="field-copy-to-clipboard-button ${reverseClass}"></button>`);
				$copyContainer.append($ctcButton);
				$ctcButton.button({
					icons: {
						primary: 'f-icon far fa-clipboard',
					},
					text: false,
					disabled: false
				})
					.css(styles)
					.css('border', '')
					.off('click.ctc')
					.on('click.ctc', (event) => {
						let name = field.data('name');
						let narrowedObj = this.getFieldValue(name);
						clipboardManager.copyText(narrowedObj[name])
							.then(s => {
								hrd.dashboard.msgBox({
									title: xlate('common.dialog.info.title.msg'),
									text: s ? xlate('common.copyToClipboard.success.txt') : xlate('common.copyToClipboard.failure.txt'),
									okLabel: xlate('common.dialog.close.btn'),
									type: 'OK',
									icon: s ? 'info' : 'warning'
								})
									.progress(dialogOptions => dialogOptions.autoClose(3000))
							});
					});
			}

			if (field.usingChromaFlow()) {
				this.wrapForCopyToClipboardAddon(field);
			}
		}
	},
	wrapForCopyToClipboardAddon: function(field) {
		if (!field.usingChromaFlow()) return;

		const wrappableSelectors = '.field-container, .editable-data, .read-only-data, .button-with-addon, .select-minimal, .wrapper-for-ctc-btn';
		const $addon = field.closest('.field-composite').find('.field-copy-to-clipboard-button');

		if ($addon.exists() && !$addon.closest('.wrapper-for-ctc-btn').exists()) {
			$addon
				.add($addon.siblings(wrappableSelectors))
				.wrapAll(`<div class="wrapper-for-ctc-btn field-container"></div>`);
		}
	},
	/**
	 *  method used to force reload of a select1/select field
	 *
	 */
	reloadSelectOptions: function(field, options) {
		var $field = this.getField(field);
		if ($field.exists()) {
			let type = $field.data('type');
			switch (type) {
				case 'select1':
				case 'select':
					$field.data('extra-options', options);
					let name = this.toPropertyName($field);
					let component = this.componentFactory.factory(name, type, 'edit');
					component.reloadField($field);
					return $.when($field.data('loaded'));
				default:
					console.log('Unable to reload a non combo-box field', field);
					return $.when();
			}
		} else {
			console.log('Unable to reload a non-existent combo-box', field);
			return $.when();
		}
	},
	/**
	 *  method used to force reload of a table field
	 *  AFAIK there is no need to wait for the table refresh to continue
	 *
	 */
	reloadFormTable: function(field) {
		var $field = this.getField(field);
		if ($field.exists()) {
			switch ($field.data('type')) {
				case 'table':
					this.setReadOnlyField($field, {}, { skipUpdateTable: false });
					return $.when();
				default:
					console.log('Unable to reload a non table field', field);
					return $.when();
			}
		} else {
			console.log('Unable to reload a non-existent table', field);
			return $.when();
		}
	},
	/**
	 *  method used to force reset of a table field
	 *  AFAIK there is no need to wait for the table refresh to continue
	 *
	 */
	clearFormTable: function(field) {
		var $field = this.getField(field);
		if ($field.exists()) {
			switch ($field.data('type')) {
				case 'table':
					this.resetReadOnlyField($field, true);
					return $.when();
				default:
					console.log('Unable to clear a non table field', field);
					return $.when();
			}
		} else {
			console.log('Unable to clear a non-existent table', field);
			return $.when();
		}
	},
	getTableManager: function(field) {
		let manager = undefined;
		var $field = this.getField(field);
		if ($field.exists()) {
			manager = $field.data('manager');
		}
		return manager;
	},
	getTableId: function(field) {
		let tableId = undefined;
		let manager = this.getTableManager(field);
		if (manager != undefined) {
			tableId = manager.settings.tableId;
		}
		return tableId;
	},
	/**
	 *  To use only with client side processing
	 *
	 */
	addFormTableData: function(field, data) {
		var $field = this.getField(field);
		if ($field.exists()) {
			switch ($field.data('type')) {
				case 'table':
					$field.data("manager").tableInstance.fnAddData(data);

					return $.when();
				default:
					console.log('Unable to add data to a non table field', field);
					return $.when();
			}
		} else {
			console.log('Unable to add data to a non-existent table', field);
			return $.when();
		}
	},
	toggleTableVisibility: function(field, formData) {
		var $field = this.getField(field);
		if ($field.exists()) {
			switch ($field.data('type')) {
				case 'table':
					var hideWhen = field.data('hideWhen');
					var formObject = formData || {};
					var hideTable = hideWhen ? $.evaluate(hideWhen, this.settings.reference, [formObject], ['formObject']) : false;
					if (hideTable == true) {
						this.hideField(field);
					} else {
						this.showField(field);
						//tableManager.refreshTable();
					}
					return $.when();
				default:
					console.log('Unable to toggle a non table field', field);
					return $.when();
			}
		} else {
			console.log('Unable to toggle a non-existent table', field);
			return $.when();
		}
	},
	/**
	 * Useful to toggle enablement internal button by its 'data-action' value and boolean param
	 */
	toggleEnablementButton: function(buttonAction, toggle) {
		var $btn = this.buttons[buttonAction];
		if ($btn) {
			$btn.button('option', 'disabled', !toggle)
		}
	},
	getButton: function(buttonAction) {
		var $btn = this.buttons[buttonAction];
		if ($btn.exists()) {
			return $btn;
		} else {
			return $('none'); // just to avoid NPE
		}
	},
	/**
	 * Useful to enable internal button by its 'data-action' value
	 */
	enableButton: function(buttonAction) {
		var $btn = this.buttons[buttonAction];
		if ($btn) {
			$btn.button('option', 'disabled', false);
		}
	},
	/**
	 * Useful to enable internal button by its 'data-action' value
	 */
	disableButton: function(buttonAction) {
		var $btn = this.buttons[buttonAction];
		if ($btn) {
			$btn.button('option', 'disabled', true);
		}
	},
	/**
	 * Useful to toggle enablement internal button by its 'data-action' value and boolean param
	 */
	toggleEnablementAllButtons: function(toggle) {
		$.each(this.buttons, function(key, $btn) {
			$btn.button('option', 'disabled', !toggle);
		});
	},
	/**
	 * Useful to enable internal button by its 'data-action' value
	 */
	enableAllButtons: function() {
		$.each(this.buttons, function(key, $btn) {
			$btn.button('option', 'disabled', false);
		});
	},
	/**
	 * Useful to enable internal button by its 'data-action' value
	 */
	disableAllButtons: function() {
		$.each(this.buttons, function(key, $btn) {
			$btn.button('option', 'disabled', true);
		})
	},
	/**
	 * Useful to toggle internal button by its 'data-action' value and boolean param
	 */
	toggleButton: function(buttonAction, toggle) {
		var $btn = this.buttons[buttonAction];
		if ($btn) {
			this.toggleField($btn, toggle);
		}
	},
	/**
	 * Useful to show internal button by its 'data-action' value
	 */
	showButton: function(buttonAction) {
		var $btn = this.buttons[buttonAction];
		if ($btn) {
			this.showField($btn);
		}
	},
	/**
	 * Useful to hide internal button by its 'data-action' value
	 */
	hideButton: function(buttonAction) {
		var $btn = this.buttons[buttonAction];
		if ($btn) {
			this.hideField($btn);
		}
	},
	/**
	 * Useful to show all internal buttons by its 'data-action' value
	 */
	toggleAllButtons: function(toggle) {
		$.each(this.buttons, function(key, $btn) {
			this.toggleField($btn, toggle);
		});
	},
	/**
	 * Useful to show all internal buttons by its 'data-action' value
	 */
	showAllButtons: function() {
		$.each(this.buttons, function(key, $btn) {
			this.showField($btn);
		});
	},
	/**
	 * Useful to hide all internal buttons by its 'data-action' value
	 */
	hideAllButtons: function() {
		$.each(this.buttons, function(key, $btn) {
			this.hideField($btn);
		})
	},
	executeButtonAction: function(action) {
		var btn = this.buttons[action];
		if (btn) {
			btn.trigger('click');
		}
	},
	setButtonLabel: function(buttonAction, label) {
		var $btn = this.getField(buttonAction);
		if ($btn.data('menu-info') != undefined) {
			$btn.data('currentDataMenuItem', label);
		}
		$btn.button('option', 'label', label);
	},
	appendToButtonLabel: function(buttonAction, suffix) {
		var $btn = this.getField(buttonAction);
		//		if ($btn.data('menu-info') != undefined) {
		//			$btn.data('currentDataMenuItem', label);
		//		}
		let originalLabel = $btn.data('originalLabel');
		if (originalLabel == undefined) {
			originalLabel = $btn.button('option', 'label');
			$btn.data('originalLabel', originalLabel);
		}
		$btn.button('option', 'label', `${originalLabel} ${suffix}`);
	},
	setButtonPrimaryIcon: function(buttonAction, icon) {
		var $btn = this.getField(buttonAction);
		$btn.button('option', 'icons', { primary: 'f-icon ' + icon });
	},
	toObjectDeferred: function(object, options) {
		var deferred = $.Deferred();

		//object = object || $(this.container).data('inputData') || {};
		object = object || this.settings.inputData || {};
		options = options || {};

		// force blur from current field with focus //
		if (!options.doNotForceBlur) {
			$('*:focus').blur();
		}
		$.when.all(this.getPromises(this.OBJECT_PHASE_PROMISES))
			.then(() => deferred.resolve(this.toObject(object, options)))
			.fail(() => deferred.reject());

		return deferred.promise();
	},
	getFields: function(container) {
		container = container || this.container;
		var fields = [];
		$(this.FIELD_SELECTOR, container).add($(this.DIV_SELECTOR, container)).each((i, f) => {
			fields.push(this.toPropertyName($(f)));
		});
		return fields;
	},
	toObject: function(object, options) {
		options = options || {};
		let extractOnly = options.extractOnly || [];
		let isNarrowed = extractOnly.length != 0;
		// if extract only mode, object == undefined means use a new object and not original inputData
		object = (isNarrowed) ? object || {} : object || this.settings.inputData || {};

		// force blur from current field with focus //
		if (!options.doNotForceBlur) {
			$('*:focus').blur();
		}

		/* read editable fields*/
		$(this.FIELD_SELECTOR, this.container).each((index, f) => {
			var field = $(f);
			var name = this.toPropertyName(field);
			if (!isNarrowed || extractOnly.includes(name)) {
				object = this.getEditableField(field, name, object, options);
			}
		});

		/* read readonly fields*/
		$(this.DIV_SELECTOR, this.container).each((index, f) => {
			var field = $(f);
			var name = this.toPropertyName(field);
			if (!isNarrowed || extractOnly.includes(name)) {
				object = this.getReadOnlyField(field, name, object, options);
			}
		});
		return object;
	},
	getEditableField: function(field, name, object, options) {
		let type = field.data('type');
		let fieldElement = field.get(0);
		let component = this.componentFactory.factory(name, type, 'edit');
		if (component) {
			component.toObject(field, object, options);
		} else {
			switch (type) {
				default:
					this.setValueByPath(object, name, field.val());
					break;
			}
		}
		return object;
	},
	getReadOnlyField: function(field, name, object, options) {
		let type = field.data('type');
		let component = this.componentFactory.factory(name, type, 'read');
		if (component) {
			component.toObject(field, object, options);
		} else {
			switch (type) {
				default:
					var value = field.data('current-value');
					if (value != undefined) {
						this.setValueByPath(object, name, value);
					} else {
						if (field.data('placeholder') != undefined) {
							this.setValueByPath(object, name, '');
						} else {
							this.setValueByPath(object, name, field.text());
						}
					}
					break;
			}
		}
		return object;
	},
	alias: function(object) {
		$(this.FIELD_SELECTOR, this.container).each(function(index, fieldElement) {
			var field = $(fieldElement);
			var name = this.toPropertyName(field);
			var value = this.getValueByPath(object, name);
			var alias = field.data('alias');
			if (alias && value !== undefined) {
				object[alias] = this.getValueByPath(object, name);
			}
		}.bind(this));
		$(this.DIV_SELECTOR, this.container).each(function(index, fieldElement) {
			var field = $(fieldElement);
			var name = this.toPropertyName(field);
			var value = this.getValueByPath(object, name);
			var alias = field.data('alias');
			if (alias && value !== undefined) {
				object[alias] = this.getValueByPath(object, name);
			}
		}.bind(this));
		return object;
	},
	/**
	 * narrowed an object copying only a subset of all available properties.
	 * As of now only 'flat' properties can be copied
	 */
	narrow: function(obj, props, skipNull) {
		skipNull = !!skipNull;
		var narrowedObj = {}, v;
		if (props) {
			props.forEach(p => {
				v = this.getValueByPath(obj, p);
				if (!skipNull || v != undefined) {
					this.setValueByPath(narrowedObj, p, v);
				}
			});
		}
		return narrowedObj;
	},
	toForm: function(object, options) {
		let alreadyEnhanced = this.alreadyEnhanced();
		let isInsideNotActiveTab = (this.settings.reference && typeof this.settings.reference.isInsideNotActiveTab == 'function') ? this.settings.reference.isInsideNotActiveTab : () => false;
		options = options || {};
		if (!alreadyEnhanced && isInsideNotActiveTab.call(this.settings.reference)) {
			this.toBeExecutedWith = { object: object, options: options };
		} else {
			if (this.toBeExecutedWith !== undefined) {
				this._toForm_(this.toBeExecutedWith.object, this.toBeExecutedWith.options);
				this.toBeExecutedWith = undefined;
			} else {
				this._toForm_(object, options);
			}
		}
	},
	/**
	 * Used to populate all fields inside a container with an object
	 *
	 * @param object
	 * @param container
	 */
	_toForm_: function(object, options) {
		options = $.extend({}, {
			noBroadcast: false,
			decorate: false,
			skipUpdateTable: false,
			forceNull: false,
			keepMissingReadOnlyValues: false
		}, options || {});

		this.settings.inputData = object; // store object into formObject and into fields

		/* fill editable fields*/
		$(this.FIELD_SELECTOR, this.container).each((index, field) => {
			this.setEditableField($(field), object, options);
		});

		/* fill readonly fields*/
		$(this.DIV_SELECTOR, this.container).each((index, field) => {
			this.setReadOnlyField($(field), object, options);
		});

		/* update button status*/
		$(this.BTN_SELECTOR, this.container).each((i, btn) => {
			var $btn = $(btn);
			this.activateButtonByProperty($btn, object);
			this.toggleVisibilityByProperty($btn, object);
		});

		if (options.decorate) {
			this.decorateForm(object);
		}
		if (!options.noBroadcast) {
			$.broadcast(this.$container, 'set-data-form');
		}
	},
	getFieldsValue: function(fields, options) {
		let narrowedObj = {};
		if ($.isArray(fields)) {
			fields.reduce((o, f) => {
				let v = this.getFieldValue(f, options);
				return $.extend(o, v);
			}, narrowedObj);
		} else {
			console.log('The given parameter is not an array ', fields);
		}
		return narrowedObj;
	},
	getFieldValue: function(f, options) {
		options = options || {};
		options.extractOnly = [f];
		let narrowedObj = this.toObject({}, options);
		return narrowedObj;
	},
	setFields: function(fields, object, options) {
		if ($.isArray(fields)) {
			fields.forEach(f => this.setField(f, object, options));
		} else {
			console.log('The given parameter is not an array ', fields);
		}
	},
	setFieldValue: function(f, object, options) {
		this.setField(f, object, options);
	},
	setField: function(f, object, options) {
		options = options || {};
		var $field = this.getField(f);
		if ($field.exists()) {
			if (!$.isPlainObject(object)) {
				var o = {};
				o[f] = object;
				object = o;
			}
			if ($field.hasClass('editable-data')) {
				this.setEditableField($field, object, options);
				// force trigger change if declared in options obj
				if (options.triggerChange) {
					$field.trigger('change');
				}
				if (options.triggerEvents) {
					// triggerEvents is a space separated list of events
					options.triggerEvents.split(' ').forEach(ev => {
						$field.trigger(ev);
					});
				}
			} else if ($field.hasClass('read-only-data') || $field.hasClass('image-field') || $field.hasClass('table-container')) {
				this.setReadOnlyField($field, object, options);
			} else {
				console.log('Reference is not a valid form field ', f);
			}
		} else {
			console.log('Not valid reference: ', f);
		}
	},
	emptyField: function(field) {
		this.setField(field, {}, { forceNull: true });
	},
	setEditableField: function(field, object, options) {
		options = options || {};
		var id = field.attr('id');
		var name = this.toPropertyName(field);
		var val = this.getValueByPath(object, name); // ""
		var alwaysSettable = ["color", "file"];
		let type = field.data('type');
		if (val !== undefined || alwaysSettable.indexOf(type) != -1 || options.forceNull) {
			let component = this.componentFactory.factory(name, type, 'edit');
			if (component) {
				component.toForm(field, val, object, options);
			} else {
				field.val(val);
			}
			field.trigger('field-has-changed', {
				previousValue: field.data('prev-val'),
				newValue: val
			});
		}
		this.toggleEnablementByProperty(field, object);
		this.toggleVisibilityByProperty(field, object);
	},
	setReadOnlyField: function(field, object, options) {
		var type = field.data('type');
		var name = this.toPropertyName(field);
		var val = this.getValueByPath(object, name);

		if (val == undefined && options.keepMissingReadOnlyValues === true) {
			val = field.data('current-value');
		}

		// store in data-current-value the visible value, usable for recreating object. remove 'data' when undefined or null
		if (val == undefined) {
			field.removeData('current-value');
		} else {
			field.data('current-value', val);
		}
		let component = this.componentFactory.factory(name, type, 'read');
		if (component) {
			component.toForm(field, val, object, options);
		} else {
			if (val != undefined) {
				if (field.data('formatStyle')) {
					var formattedVal = hrd.datatable.formatCellData.call(this, val, field.data('formatStyle'));
					field.html(formattedVal);
				} else {
					field.text(val);
				}
			} else {
				field.text('');
			}
		}
		if ((val == undefined || val == '') && (field.data('placeholder'))) {
			// if val is undefined, nothing should happen, if value is empty placehoder should appear
			field.append($(`<span class="placeholder">${field.data('placeholder')}</span>`));
		}
		this.toggleVisibilityByProperty(field, object);
	},
	formToggleVisibility: function() {
		var formData = this.toObject();
		/* editable fields*/
		$(this.FIELD_SELECTOR, this.container).each((j, field) => {
			var $f = $(field);
			this.toggleVisibilityByProperty($f, formData);
			this.toggleEnablementByProperty($f, formData);
		});

		/* readonly fields*/
		$(this.DIV_SELECTOR, this.container).each((j, field) => {
			var $f = $(field);
			this.toggleVisibilityByProperty($f, formData);
			this.toggleEnablementByProperty($f, formData);
			//this.toggleTableVisibility($f, formData);
		});

		/* buttons*/
		$(this.BTN_SELECTOR, this.container).each((j, btn) => {
			var $btn = $(btn);
			this.activateButtonByProperty($btn, formData);
			this.toggleVisibilityByProperty($btn, formData);
		});
	},
	/**
	 *  hide/show dynamically field based on some properties
	 */
	toggleVisibilityByProperty: function($f, formData) {
		var object = formData || this.settings.inputData;
		var hasVisibilityProperty = false;
		var hideProperty = $f.data('hideProperty');
		var showProperty = $f.data('showProperty');
		var showIfRole = $f.data('showIfRole');
		var showExpression = $f.data('showExpr');
		var hidden = $f.data('hidden');
		var hide = false;
		if (hideProperty) {
			hide = this.getValueByPath(object, hideProperty);
			hasVisibilityProperty = true;
		} else if (showProperty) {
			hide = !this.getValueByPath(object, showProperty);
			hasVisibilityProperty = true;
		} else if (showIfRole != undefined) {
			if (!dashboardInstance.hasPermissionData(showIfRole)) {
				console.log(`The permission "${showIfRole}" is not available in current dashboard`);
				hide = false;
			} else {
				hide = !dashboardInstance.hasPermission(showIfRole);
			}
			hasVisibilityProperty = true;
		} else if (showExpression != undefined) {
			var formObject = object || {};
			var evaluated = $.evaluate(showExpression, this.settings.reference, [formObject, $f], ['formObject', 'field']);
			hide = !evaluated;
			hasVisibilityProperty = true;
		} else if (hidden != undefined) {
			hide = !!hidden;
			hasVisibilityProperty = true;
		}
		if (hasVisibilityProperty) {
			if (hide) {
				this.hideField($f);
			} else {
				this.showField($f);
			}
		}
	},
	/**
	 *  enable/disable dynamically field based on some properties
	 */
	toggleEnablementByProperty: function($f, formData) {
		var object = formData || this.settings.inputData;
		var disableProperty = $f.data('disableProperty');
		var enableProperty = $f.data('enableProperty');
		var enableIfRole = $f.data('enableIfRole');
		var enableExpression = $f.data('enableExpr');
		var disable = undefined;
		if (disableProperty) {
			disable = this.getValueByPath(object, disableProperty);
		} else if (enableProperty) {
			disable = !this.getValueByPath(object, enableProperty);
		} else if (enableIfRole != undefined) {
			if (!dashboardInstance.hasPermissionData(showIfRole)) {
				console.log(`The permission "${enableIfRole}" is not available in current dashboard`);
				disable = false;
			} else {
				disable = !dashboardInstance.hasPermission(enableIfRole);
			}
		} else if (enableExpression) {
			var formObject = object || {};
			var evaluated = $.evaluate(enableExpression, this.settings.reference, [formObject, $f], ['formObject', 'field']);
			disable = !evaluated;
		}
		if (disable != undefined) {
			this.disableField($f, disable);
		}
	},
	/**
	 * Similar to toggleEnablementByProperty but for buttons
	 */
	activateButtonByProperty: function($btn, formData) {
		var object = formData || this.settings.inputData;
		var hasActivateProperty = false;
		var disableProperty = $btn.data('disableProperty');
		var enableProperty = $btn.data('enableProperty');
		var enableExpression = $btn.data('enableExpr');
		if (disableProperty) {
			$btn.button({ disabled: this.getValueByPath(object, disableProperty) });
			hasActivateProperty = true;
		} else if (enableProperty) {
			$btn.button({ disabled: !this.getValueByPath(object, enableProperty) });
			hasActivateProperty = true;
		} else if (enableExpression) {
			var formObject = object || {};
			var evaluated = $.evaluate(enableExpression, this.settings.reference, [formObject, $btn], ['formObject', 'btn']);
			$btn.button({ disabled: !evaluated });
			hasActivateProperty = true;
		}
		return hasActivateProperty;
	},
	/**
	 *
	 */
	initForm: function() {
		$(this.FIELD_SELECTOR, this.container).each((index, f) => {
			this.initField($(f), 'edit');
		});
	},
	initField: function(f, mode) {
		let field = this.getField(f);
		let initialValue = field.data('default');
		let type = field.data('type');
		let name = this.toPropertyName(field);
		let component = this.componentFactory.factory(name, type, mode);
		if (initialValue !== undefined) {
			if (component != null) {
				component.initalizeComponent(field, initialValue);
			} else {
				field.val(initialValue);
			}
		} else {
			// default initialization, but skipped if field declares to ignore it
			if (!!field.data('ignore-init')) {
				return;
			}
			if (component != null) {
				component.initalizeComponentWithUndefined(field);
			}
		}
	},
	resetForm: function(forceReset, options) {
		options = options || {};
		forceReset = !!forceReset;
		if (this.alreadyEnhanced()) {
			// non serve resettare se non ancora enhanced
			this.settings.inputData = undefined;
			this.$form.removeErrorStyle(hrd.dashboard.validate.isValidConfig());
			$(this.FIELD_SELECTOR, this.container).each((index, f) => {
				this.resetEditField($(f), forceReset, options);
			});
			$(this.DIV_SELECTOR, this.container).each((index, f) => {
				this.resetReadOnlyField($(f), forceReset, options);
			});
			this.resetChanges()
		} else {
			console.info('skip reset form because not already enhanced')
		}
	},
	/**
	 * Perform reset of all given fields
	 * @param: list of field names
	 */
	resetField: function() {
		var fields = $.argsArray(arguments);
		fields.forEach(field => {
			var $f = this.getField(field);
			if ($f.hasClass('editable-data')) {
				this.resetEditField($f, true);
			} else if ($f.hasClass('read-only-data')) {
				this.resetReadOnlyField($f, true);
			} else {
				console.log('Not possible to reset "' + field + '" element');
			}
		})
	},
	resetEditField: function(field, forceReset, options) {
		options = options || {};
		let id = field.attr('id');
		let name = this.toPropertyName(field);
		let type = field.data('type');
		var skipReset = !!field.data('skip-reset');
		var resetField = !skipReset || forceReset;
		if (resetField) {
			let component = this.componentFactory.factory(name, type, 'edit');
			if (component) {
				component.reset(field, options);
			} else {
				switch (type) {
					default:
						field.val('');
						break;
				}
			}
		}
		if (field.data('hidden')) {
			this.hideField(field);
		}
	},
	resetReadOnlyField: function(field, forceReset, options) {
		options = $.extend({
			skipResetTable: false,
			resetSelectionOnly: false
		}, options);
		let name = this.toPropertyName(field);
		let type = field.data('type');

		if (field.data('hidden')) {
			this.hideField(field);
		}
		var id = field.attr('id');
		// force reset 'current-value' in order to avoid 'leaks' due to previous data stored in form
		field.removeData('current-value');
		let component = this.componentFactory.factory(name, type, 'read');
		if (component) {
			component.reset(field, options);
		} else {
			switch (type) {
				default:
					field.text('');
					if (field.data('placeholder')) {
						field.append($('<span class="placeholder">' + field.data('placeholder') + '</span>'));
					}
					break;
			}
		}
	},
	/**
	 * Used to enable/disable all fields of a form container
	 * If in option a specific property is present with a boolean value, than that value will be used for enabling/disablig that field
	 *
	 * @param container
	 * @param options
	 */
	disableForm: function(options) {
		var disabled;
		var defaultOptions = {
			disabled: true,
			exclude: []
		}
		options = $.extend(defaultOptions, options);
		$(this.FIELD_SELECTOR, this.container).each(function(index, f) {
			var field = $(f);
			var id = field.attr('id');
			var name = (id != undefined) ? $.camelCase(id) : undefined;
			var dataName = field.data('name');
			if (options.exclude.indexOf(id) == -1 && options.exclude.indexOf(name) == -1 && options.exclude.indexOf(dataName) == -1) {
				disabled = (options[id] !== undefined) ? options[id] : (options[name] !== undefined) ? options[name] : (options[dataName] !== undefined) ? options[dataName] : options.disabled;
				field.attr('disabled', disabled);
				this.disableField(field, disabled);
			}
		}.bind(this));
		$(this.BTN_SELECTOR, this.container).each(function(i, btn) {
			var $btn = $(btn);
			var action = $btn.data('action');
			if (options.exclude.indexOf(action) == -1) {
				disabled = (options[action] !== undefined) ? options[action] : options.disabled;
				$btn.button({ disabled: disabled });
			}
		}.bind(this));
	},
	enableForm: function(options) {
		options = options || {};
		options.disabled = false;
		this.disableForm(options);
	},
	toggleFormElementEnablement: function(field, enable) {
		enable = (enable == undefined) ? true : enable;
		if (enable) {
			this.enableFormElement(field);
		} else {
			this.disableFormElement(field);
		}
	},
	disableFormElement: function(field) {
		var $f = this.getField(field);
		if ($f.hasClass('editable-data') || $f.hasClass('choice-group')) {
			this.disableField($f, true);
		} else if ($f.data('action')) {
			$f.button({ disabled: true });
		} else {
			console.log('The form element "' + field + '" cannot be disabled');
		}
	},
	enableFormElement: function(field) {
		var $f = this.getField(field);
		if ($f.hasClass('editable-data') || $f.hasClass('choice-group')) {
			this.disableField($f, false);
		} else if ($f.data('action')) {
			$f.button({ disabled: false });
		} else {
			console.log('The form element "' + field + '" cannot be disabled');
		}
	},
	disableField: function(field, disable) {
		let type = field.data('type');
		let name = this.toPropertyName(field);
		let component = this.componentFactory.factory(name, type, 'edit');
		if (component) {
			component.disableField(field, disable);
		} else {
			switch (type) {
				default:
					field.attr('disabled', disable);
					break;
			}
		}
	},
	decorateForm: function(formObject) {
		formObject = formObject || this.toObject();
		$(this.FIELD_SELECTOR, this.container).add($(this.DIV_SELECTOR, this.container)).add($(this.BTN_SELECTOR, this.container))
			.each((i, f) => {
				this.decorateField($(f), formObject);
			});
	},
	decorateField: function(field, formObject) {
		var id = field.attr('id');
		var sDecoration = field.data('decorate');
		if (sDecoration) {
			var fnName = (sDecoration == true) ? $.camelCase(id + '-decorate') : sDecoration;
			if (this.settings.reference && typeof this.settings.reference[fnName] == 'function') {
				this.settings.reference[fnName].call(this.settings.reference, field, formObject, this);
			} else {
				if (field.data('name') != undefined) {
					var alternateFnName = $.functionCase(field.data('name') + '-decorate');
					if (this.settings.reference && typeof this.settings.reference[alternateFnName] == 'function') {
						this.settings.reference[alternateFnName].call(this.settings.reference, field, formObject, this);
					} else {
						console.log('Decoration NOT available. Use "' + fnName + '" or "' + alternateFnName + '"');
					}
				} else {
					var alternateBtnFnName = $.camelCase(field.data('action') + '-decorate');
					if (this.settings.reference && typeof this.settings.reference[alternateBtnFnName] == 'function') {
						this.settings.reference[alternateBtnFnName].call(this.settings.reference, field, formObject, this);
					} else {
						console.log('Decoration NOT available. Use "' + fnName + '" or "' + alternateBtnFnName + '"');
					}
				}
			}
		}
	},
	resizeForm: function() {
		$(this.FIELD_SELECTOR, this.container).add($(this.DIV_SELECTOR, this.container)).add($(this.BTN_SELECTOR, this.container)).each((i, f) => {
			var field = $(f);
			var id = field.attr('id');
			var type = field.data('type');
			switch (type) {
				case 'image':
					if (field.data('editable')) {
						var $parent = field.parent();
						var editableInfo = $.evaluate(field.data('editable'));
						var $ei = $('.editable-image', $parent);
						var position;
						switch (editableInfo.position) {
							case 'rb':
								position = { my: "left+10 bottom+3", at: "right bottom", of: field };
								break;
							case 'lt':
								position = { my: "right-10 top", at: "left top", of: field };
								break;
							case 'lb':
								position = { my: "right-10 bottom+3", at: "left bottom", of: field };
								break;
							case 'rt':
							default:
								position = { my: "left+10 top", at: "right top", of: field };
								break;
						}
						$ei.position(position);
					}
					break;
				case 'canvas':
					// need to resize help position
					let fieldHelpKey = field.data('help');
					if (fieldHelpKey != undefined) {
						let $helpButton = field.find('.field-help-button');
						let $canvas = field.find('canvas');
						let left = 16 + ((field.width() + $canvas.outerWidth(true)) / 2);
						$helpButton.css('left', left);
					}
					break;
				default:
					// do nothing
					break;
			}
		});
	},
	makeFormEdited: function() {
		if (!this.formHasBeenEdited) {
			if (this.settings.reference && typeof this.settings.reference.markAsEdited == 'function') {
				this.settings.reference.markAsEdited.call(this.settings.reference, true);
			} else if (this.isFormDialog()) {
				var dialogId = this.$container.attr('id');
				$('#' + dialogId).dialog('markAsEdited', true);
			}
		}
		this.formHasBeenEdited = true;
	},
	confirmChanges: function() {
		if (this.formHasBeenEdited) {
			if (this.settings.reference && typeof this.settings.reference.markAsEdited == 'function') {
				this.settings.reference.markAsEdited.call(this.settings.reference, false);
			} else if (this.isFormDialog()) {
				var dialogId = this.$container.attr('id');
				$('#' + dialogId).dialog('markAsEdited', false);
			}
		}
		this.formHasBeenEdited = false;
	},
	resetChanges: function() {
		this.confirmChanges();
	},
	/**
	 * Detects if the form has changed from its initial state
	 * It looks for changes only in editable fields, checking prev-value with the one available in toObject object
	 */
	hasChanged: function(withoutSaveButton) {
		withoutSaveButton = !!withoutSaveButton;
		var deferred = $.Deferred();
		if (this.formHasBeenEdited) {
			hrd.dashboard.msgBox({
				title: xlate('common.dialog.warning.title.msg'),
				text: withoutSaveButton ? xlate('common.dialog.document.haschanged.noSave.title.msg') : xlate('common.dialog.document.haschanged.withSave.title.msg'),
				okLabel: withoutSaveButton ? xlate('common.dialog.doNotSave.btn') : xlate('common.dialog.save.btn'),
				koLabel: xlate('common.dialog.doNotSave.btn'),
				cancelLabel: xlate('common.dialog.cancel.btn'),
				type: withoutSaveButton ? 'OK_CANCEL' : 'YES_NO_CANCEL'
			})
				.always(r => {
					if (!r.isCancel()) {
						this.resetChanges();
					}
					if (withoutSaveButton) {
						deferred.resolve(r.isCancel() ? 'stop' : 'continue');
					} else {
						deferred.resolve(r.isOk() ? 'save' : r.isCancel() ? 'stop' : 'continue');
					}
				});
		} else {
			deferred.resolve('continue');
		}
		return deferred.promise();
	},
	removeValidationErrors: function() {
		this.$form.removeErrorStyle(hrd.dashboard.validate.isValidConfig());
	},
	removeFieldValidationError: function(field) {
		const $field = this.getField(field);

		if ($field.exists()) {
			this.$form.removeFieldErrorStyle($field, hrd.dashboard.validate.isValidConfig());
		}
	},
	validateField: function(fieldName, inputData) {
		return this.validate(inputData, [fieldName]);
	},
	validateFields: function(fields, inputData) {
		if ($.isArray(fields)) {
			return this.validate(inputData, fields);
		} else {
			console.log('The given parameter is not an array ', fields);
			return $.never();
		}
	},
	/**
	 *  Used to validate the form itself
	 *  as-of 9/1/21 behavior has changed in order to support remotable valdations. Now returns a resolved promise when 'valid', a rejected one when invalid
	 */
	validate: function(inputData, validateOnlyThese) {
		validateOnlyThese = validateOnlyThese || [];
		var deferred = $.Deferred();
		this.$container.waiting(); // block form
		inputData = inputData || this.toObject(); // retrieves object if not passed
		// stores input data into form object because validation framework need it
		this.$form.data('inputData', inputData);
		this.$form.data('formInstance', this);
		var validConfig = hrd.dashboard.validate.isValidConfig();

		validConfig.errorMessagePosition = this.settings.errorMessagePosition;
		validConfig.errorMessageParentSelector = this.settings.errorMessageParentSelector;
		if (this.settings.errorMessageCustom != undefined) {
			validConfig.errorMessageCustom = this.settings.errorMessageCustom;
		}
		if (this.settings.ignoreValidationWhenHidden || validateOnlyThese.lenght > 0) {
			var ignore = [];
			// ciclo su tutti i campi, se sono nascosti li aggiungo qui
			$(this.FIELD_SELECTOR, this.container)
				.add($(this.DIV_SELECTOR, this.container))
				.each((i, f) => {
					let $f = $(f);
					let name = $f.data('name');
					let $composite = $f.closest('.field-composite');
					let $element = $composite.exists() ? $composite : $f;
					let isVisible = $element.is(':visible');
					let ignoreByVisibility = (!isVisible && this.settings.ignoreValidationWhenHidden);
					let ignoreByName = ((validateOnlyThese.length > 0) && !validateOnlyThese.includes(name));
					let ignoreValidation = ignoreByVisibility || ignoreByName;
					if (ignoreValidation) {
						if ($f.hasClass('choice-group')) {
							ignore.push($f.attr('id') + '-group');
						} else {
							ignore.push($f.attr('id'));
						}
					}
				});
			validConfig.ignore = ignore;
		}
		this.$form.isValid(hrd.dashboard.validate.language(this.settings.extraValidations), validConfig)
			.then(isValid => {
				this.$container.waiting('done'); // release form
				if (this.settings.reference != null && typeof this.settings.reference['onFormValidated'] === 'function') {
					this.settings.reference['onFormValidated'].call(this.settings.reference, isValid);
				}
				if (isValid) {
					if (this.$form.data('validationBox') !== undefined) {
						this.$form.data('validationBox').close();
						this.$form.removeData('validationBox');
					}
					deferred.resolve();
				} else {
					deferred.reject();
				}
			});
		return deferred.promise();
	},
	/**
	 * The field name is computed in one of the following names (the first not null will win)
	 * 		- use the "data-name" html attribute
	 * 		- use the "name" html attribute with a camelCase conversion
	 * 		- use the "id" html attribute with a camelCase conversion
	 * @param field - the field as jquery object
	 * @returns the prpoerty name of that field
	 */
	toPropertyName: function(field) {
		var name;
		var dataName = field.data('name');
		if (typeof dataName === 'function') {
			name = dataName();
		} else {
			name = field.data('name') || (field.attr('name') ? $.camelCase(field.attr('name')) : undefined) || (field.attr('id') ? $.camelCase(field.attr('id')) : undefined);
		}
		return name;
	},
	/**
	 * Due to legacy code, search for "one-level" properties, if not found search for the deep one
	 */
	getValueByPath: function(obj, path) {
		var value;
		if (obj != undefined) {
			if (obj.hasOwnProperty(path)) {
				value = obj[path];
			} else {
				value = objectPath.get(obj, path);
			}
		}
		return value;
	},
	/**
	 * Due to legacy code, search for "one-level" properties, if it "hasOwnProperty" use that property, if not found use the deep one
	 */
	setValueByPath: function(obj, path, value) {
		if (obj != undefined) {
			if (obj.hasOwnProperty(path)) {
				obj[path] = value;
			} else {
				objectPath.set(obj, path, value);
			}
		}
	},
	utils: function() {
		return {
			date: dateConfigs,
			time: timeConfigs,
			number: numberConfigs,
			getMaxLength: getMaxLength,
			createCharCounterMessage: createCharCounterMessage,
			leftPad: leftPad,
			rightPad: rightPad
		};
		function getMaxLength($field, text) {
			var hasText = text != undefined;
			var maxLength;
			var fnMaxLenght = $field.data('fn-max-length');
			if (fnMaxLenght && typeof fnMaxLenght === 'function' && hasText) {
				maxLength = fnMaxLenght($field, text);
			} else {
				maxLength = $field.data('max-length');
			}
			return maxLength;
		};
		function createCharCounterMessage(from, to) {
			return '[' + from + '/' + to + ']';
		};
		function leftPad(str, size, padStr) {
			padStr = padStr || ' ';
			size = size || 5;
			var padding = Array(size).join(padStr)
			return (padding + str).slice(-size);
		};
		function rightPad(str, size, padStr) {
			padStr = padStr || ' ';
			size = size || 5;
			var padding = Array(size).join(padStr)
			return (str + padding).substring(0, size);
		};
		function dateConfigs() {
			return {
				options: options,
				dateFormat: dateFormat,
				dayMonthYearFormat: dayMonthYearFormat,
				dayMonthFormat: dayMonthFormat,
				monthYearFormat: monthYearFormat,
				patternToDate: patternToDate,
				toMomentDateFormat: toMomentDateFormat,
			};
			function options(format) {
				format = format || 'd-m-y';
				var options;
				switch (format) {
					case 'd-m-y':
						options = this.dayMonthYearFormat();
						break;
					case 'd-m':
						options = this.dayMonthFormat();
						break;
					case 'm-y':
						options = this.monthYearFormat();
						break;
					case 'multi':
						options = {
							numberOfMonths: [1, 3]
						};
						break;
					default:
						options = this.dayMonthYearFormat();
						break;
				}
				options = $.extend({}, options, {
					showOn: "button",
					buttonText: "",
					/* custom-property added just for best compatibility with font-awesome */
					buttonIcon: "f-icon fas fa-calendar-alt"
				});
				return options;
			};
			function dateFormat(date, format) {
				var mDate = moment(date);
				return mDate.format(this.toMomentDateFormat(format));
			};
			function dayMonthYearFormat() {
				var options = {
					changeMonth: true,
					changeYear: true,
					yearRange: 'c-80:c+20',
					dateFormat: 'dd/mm/yy'
				};
				return options;
			};
			function dayMonthFormat() {
				var options = {
					changeMonth: true,
					changeYear: false,
					dateFormat: 'dd/mm'
				};
				return options;
			};
			function monthYearFormat() {
				var options = {
					changeMonth: true,
					changeYear: true,
					yearRange: 'c-80:c+20',
					dateFormat: 'mm/yy'
				};
				return options;
			};
			function patternToDate(pattern, format) {
				var patterns = pattern.split(';');
				/* create moment date */
				var date = patterns.reduce((d, ptn) => patternToDate0(d, ptn), moment());
				/* format date accordingly */
				return date.format(this.toMomentDateFormat(format));
			};
			function patternToDate0(date, pattern) {
				var newDate = date.clone();
				switch (pattern) {
					case 'today':
						break;
					default:
						if (pattern.indexOf('start-of') != -1) {
							var period = pattern.split('-')[2];
							newDate.startOf(period);
						} else if ((pattern.indexOf('end-of') != -1)) {
							var period = pattern.split('-')[2];
							newDate.endOf(period);
						} else if ((pattern.indexOf('today+') != -1)) {
							var quantity = pattern.split('+')[1];
							var tokens = quantity.match(/^(\d*)(.*)$/);
							var period = (tokens[2] == 'y') ? 'years' : (tokens[2] == 'm') ? 'months' : 'days';
							newDate.add(tokens[1], period);
						} else if ((pattern.indexOf('today-') != -1)) {
							var quantity = pattern.split('-')[1];
							var tokens = quantity.match(/^(\d*)(.*)$/);
							var period = (tokens[2] == 'y') ? 'years' : (tokens[2] == 'm') ? 'months' : 'days';
							newDate.subtract(tokens[1], period);
						} else if ((pattern.indexOf('add-') != -1)) {
							var tokens = pattern.split('-');
							newDate.add(tokens[1], tokens[2]);
						} else if ((pattern.indexOf('subtract-') != -1)) {
							var tokens = pattern.split('-');
							newDate.subtract(tokens[1], tokens[2]);
						}
						break;
				}
				return newDate;
			};

			function toMomentDateFormat(format) {
				switch (format) {
					case 'd-m-y':
						return 'DD/MM/YYYY';
					case 'd-m':
						return 'DD/MM';
					case 'm-y':
						return 'MM/YYYY';
					default:
						return 'DD/MM/YYYY';
				}
			}
		};
		function timeConfigs() {
			return {
				options: options,
				patternToTime: patternToTime,
				timeFormat: timeFormat,
				toMomentTimeFormat: toMomentTimeFormat,
				hourMinutesFormat: hourMinutesFormat,
				hourMinutesSecondsFormat: hourMinutesSecondsFormat
			};
			function options(format) {
				format = format || 'h-m';
				var options;
				switch (format) {
					case 'h-m-s':
						options = this.hourMinutesSecondsFormat();
						break;
					case 'h-m':
						options = this.hourMinutesFormat();
						break;
					default:
						options = this.hourMinutesFormat();
						break;
				}
				options = $.extend({}, options, {
					showOn: "button",
					buttonText: "",
					/* custom-property added just for best compatibility with font-awesome */
					buttonIcon: "f-icon far fa-clock",
					stepHour: 1,
					stepMinute: 5, //richiesto da Boss - rispostato a 5 (da rendere configurabile)
					hourGrid: 2,
					minuteGrid: 10,
					hourMin: function() {
						var t = (hrd.globals.prefs.node.openTime) ? hrd.globals.prefs.node.openTime : '00:00';
						return parseInt(t.substring(0, 2));
					}(),
					hourMax: function() {
						var t = (hrd.globals.prefs.node.closeTime) ? hrd.globals.prefs.node.closeTime : '23:00';
						return parseInt(t.substring(0, 2));
					}()
				});
				return options;
			};
			function timeFormat(time, format) {
				var mTime = moment(time);
				return mTime.format(this.toMomentTimeFormat(format));
			};
			function hourMinutesFormat() {
				var options = {
					timeFormat: 'HH:mm',
				};
				return options;
			};
			function hourMinutesSecondsFormat() {
				var options = {
					timeFormat: 'HH:mm:ss',
				};
				return options;
			};
			function patternToTime(pattern, format) {
				var patterns = pattern.split(';');
				/* create moment time */
				var time = patterns.reduce((t, ptn) => patternToTime0(t, ptn), moment());
				/* format time accordingly */
				return time.format(this.toMomentTimeFormat(format));
			};
			function patternToTime0(time, pattern) {
				var newTime = time.clone();
				switch (pattern) {
					case 'now':
						break;
					default:
						if (pattern.indexOf('start-of') != -1) {
							var period = pattern.split('-')[2];
							newTime.startOf(period);
						} else if ((pattern.indexOf('end-of') != -1)) {
							var period = pattern.split('-')[2];
							newTime.endOf(period);
						} else if ((pattern.indexOf('round-to') != -1)) {
							var period = pattern.split('-')[2];
							newTime.minute(period * Math.round(newTime.minute() / period));
						} else if ((pattern.indexOf('now+') != -1)) {
							var quantity = pattern.split('+')[1];
							var tokens = quantity.match(/^(\d*)(.*)$/);
							var period = (tokens[2] == 'm') ? 'minutes' : 'hours';
							newTime.add(tokens[1], period);
						} else if ((pattern.indexOf('now-') != -1)) {
							var quantity = pattern.split('-')[1];
							var tokens = quantity.match(/^(\d*)(.*)$/);
							var period = (tokens[2] == 'm') ? 'minutes' : 'hours';
							newTime.subtract(tokens[1], period);
						} else if ((pattern.indexOf('add-') != -1)) {
							var tokens = pattern.split('-');
							newTime.add(tokens[1], tokens[2]);
						} else if ((pattern.indexOf('subtract-') != -1)) {
							var tokens = pattern.split('-');
							newTime.subtract(tokens[1], tokens[2]);
						}
						break;
				}
				return newTime;
			}
			function toMomentTimeFormat(format) {
				switch (format) {
					case 'h-m-s':
						return 'HH:mm:ss';
					case 'h-m':
						return 'HH:mm';
					default:
						return 'HH:mm';
				}
			}
		};
		function numberConfigs() {
			return {
				separators: separators
			};
			function separators() {
				var language = hrd.xlate.language, decimal, thousand;
				switch (language) {
					case 'it':
						decimal = ',';
						thousand = '.';
						break;
					case 'en':
						decimal = '.';
						thousand = ',';
						break;
					case 'ru':
						decimal = ',';
						thousand = ' ';
						break;
					default:
						decimal = '.';
						thousand = ',';
						break;
				}
				// forcing IT syntax
				return {
					decimal: ',',
					thousand: '.'
				};
			}
		};
	},
	toggleField: function($field, toggle, force) {
		if (toggle == true) {
			this.showField($field, force);
		} else {
			this.hideField($field, force);
		}
	},
	showField: function($field, force) {
		force = !!force;
		$field = this.getField($field);
		var toggleOnlyMe = $field.data('toggle-only-me');
		let checkForEmptyFieldset = true;

		// show only if not already visible or forced
		var parentComposite = $field.closest('.field-composite');
		if (toggleOnlyMe == true) {
			$field.show();
			checkForFieldset = false;
		} else if (parentComposite.exists()) {
			if (!parentComposite.is(':visible') || force) {
				parentComposite.show();
				var $label = $('label:not(.ignore-aw)', parentComposite);
				if ($label.exists() && this.arrangeFieldValues && this.arrangeFieldValues.labelsWidth) {
					$label.width(this.arrangeFieldValues.labelsWidth);
				}
				var inlineWidth = $field.inlineStyle('width');
				var shouldComputeWidth = $field.data('computeWidth');
				if (!$field.hasClass('ui-button') && (inlineWidth == undefined || inlineWidth == '' || (shouldComputeWidth == true))) {
					$field.fillHorizontalSpace();
				}
			}
		} else {
			if (!$field.is(':visible') || force) {
				var legend = $field.closest('.dashlet-legend');
				if (legend.exists()) {
					// it could be inside a legend
					$field.closest('.dashlet-legend').show();
				} else {
					// could be a stand-alone element (like a button)
					$field.show();
				}
			}
		}
		let parentFieldset = $field.closest('.fieldset.empty-fieldset');
		if (parentFieldset.exists() && checkForEmptyFieldset) {
			parentFieldset.removeClass('empty-fieldset');
		}
	},
	hideField: function($field, force) {
		force = !!force;
		$field = this.getField($field);
		var toggleOnlyMe = $field.data('toggle-only-me');
		let checkForParentFieldset = true;

		// hide only if not already hidden or forced
		var parentComposite = $field.closest('.field-composite');
		if (toggleOnlyMe == true) {
			$field.hide();
			checkForParentFieldset = false;
		} else if (parentComposite.exists()) {
			if (parentComposite.is(':visible') || force) {
				parentComposite.hide();
			}
		} else {
			if ($field.is(':visible') || force) {
				var legend = $field.closest('.dashlet-legend');
				if (legend.exists()) {
					// it could be inside a legend
					$field.closest('.dashlet-legend').hide();
				} else {
					// could be a stand-alone element (like a button)
					$field.hide();
				}
			}
		}
		// hiding parent fieldset hierarchy: applied iff parentFieldset is visible with zero-height
		let parentFieldset = $field.closest('.fieldset');
		if (parentFieldset.height() == 0 && parentFieldset.is(':visible') && checkForParentFieldset) {
			parentFieldset.addClass('empty-fieldset');
		}
	},
	isFormDialog: function() {
		return (typeof this.settings.innerFormButtonsFn == 'function');
	}
});